<template>
    <div class="columns is-multiline m-t-20">

        <div class="column is-full has-text-left">
            <p class="title is-size-4">Metodos de envio</p>
        </div>

        <div class="column is-full has-text-left">
            <article v-for="envio in envios" :key="envio.id" class="media">
                <div class="media-left">
                    <b-radio
                    v-model="selectedEnvioId"
                    type="is-info"
                    size="is-medium"
                    :native-value="envio.id"
                    @input="emitEnvioChange(envio)">
                    </b-radio>
                </div>
                <div class="media-content">
                    <p><strong>{{envio.title}}</strong> <span v-if="envio.freeFrom > 0" class="tag is-success is-size-small is-rounded">Gratis a partir de UY${{envio.freeFrom}}</span></p>
                    <p>
                        {{envio.details}}
                    </p>
                </div>
            </article>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        envios:{
            type:Array,
            default:new Array([])
        }
    },
    data(){
        return{
            selectedEnvioId:"",
        }
    },
    methods:{
        emitEnvioChange(envio){
            this.$emit("envioChange", envio)
        }
    },
    created(){
        if(this.envios.length){
            this.selectedEnvioId = this.envios[0].id
            this.$emit("envioChange", this.envios[0])
        }
    }
}
</script>